import { useState } from 'react';
import type { HighLevelIssue } from '../types/content';
import { getCategoryImageUrl } from '../lib/categoryImages';

interface CategoryImageProps {
  issue: Pick<HighLevelIssue, 'slug' | 'title'>;
  className?: string;
  /** When true, image is decorative (empty alt). */
  decorative?: boolean;
  /** Eager load for above-the-fold / prefetched images (offline-friendly). */
  eager?: boolean;
}

export function CategoryImage({ issue, className, decorative, eager }: CategoryImageProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <div className={`category-image-fallback ${className ?? ''}`} aria-hidden />;
  }

  return (
    <img
      src={getCategoryImageUrl(issue)}
      alt={decorative ? '' : issue.title}
      className={className}
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : undefined}
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
